import { useState } from 'react';
import { faqData } from '@/mocks/site-info';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">快速了解97视频的使用方式</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-sm font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`ri-arrow-down-s-line text-sm ${openIndex === index ? 'text-white' : 'text-foreground-500'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}